module.exports = __webpack_public_path__ + "./images/78a9dcdd60e4c5dfbfce2e59022dbd2f.webp";